"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class TrainingModuleVersion {
  static thaw(trainingModuleVersionObj) {
    if (trainingModuleVersionObj == null) return null;
    const trainingModuleVersion = new TrainingModuleVersion();
    if (trainingModuleVersionObj.id != null) trainingModuleVersion.setId(trainingModuleVersionObj.id);
    if (trainingModuleVersionObj.semanticVersion != null) trainingModuleVersion.setSemanticVersion(trainingModuleVersionObj.semanticVersion);
    if (trainingModuleVersionObj.releaseDate != null) trainingModuleVersion.setReleaseDate(trainingModuleVersionObj.releaseDate);
    if (trainingModuleVersionObj.isActive != null) trainingModuleVersion.setIsActive(trainingModuleVersionObj.isActive == null ? null : trainingModuleVersionObj.isActive ? true : false);
    if (trainingModuleVersionObj.trainingModuleId != null) trainingModuleVersion.setTrainingModuleId(trainingModuleVersionObj.trainingModuleId);
    if (trainingModuleVersionObj.trainingModule != null) trainingModuleVersion.setTrainingModule(_.TrainingModule.thaw(trainingModuleVersionObj.trainingModule));
    if (trainingModuleVersionObj.appVersions != null) trainingModuleVersion.setAppVersions(_.AppVersion.thawList(trainingModuleVersionObj.appVersions));
    if (trainingModuleVersionObj.evaluationVersions != null) trainingModuleVersion.setEvaluationVersions(_.EvaluationVersion.thawList(trainingModuleVersionObj.evaluationVersions));
    if (trainingModuleVersionObj.continuingEducationCredits != null) trainingModuleVersion.setContinuingEducationCredits(trainingModuleVersionObj.continuingEducationCredits);
    if (trainingModuleVersionObj.evaluatorTrainings != null) trainingModuleVersion.setEvaluatorTrainings(_.EvaluatorTraining.thawList(trainingModuleVersionObj.evaluatorTrainings));
    return trainingModuleVersion;
  }

  static thawList(trainingModuleVersionObjList) {
    if (trainingModuleVersionObjList == null) return [];
    var trainingModuleVersions = [];

    for (var i = 0; i < trainingModuleVersionObjList.length; i++) {
      trainingModuleVersions.push(TrainingModuleVersion.thaw(trainingModuleVersionObjList[i]));
    }

    return trainingModuleVersions;
  }

  static freeze(trainingModuleVersion) {
    if (trainingModuleVersion == null) return null;
    var trainingModuleVersionObj = {};
    if (trainingModuleVersion.getId() != null) trainingModuleVersionObj.id = trainingModuleVersion.getId();
    if (trainingModuleVersion.getSemanticVersion() != null) trainingModuleVersionObj.semanticVersion = trainingModuleVersion.getSemanticVersion();
    if (trainingModuleVersion.getReleaseDate() != null) trainingModuleVersionObj.releaseDate = trainingModuleVersion.getReleaseDate();
    if (trainingModuleVersion.getIsActive() != null) trainingModuleVersionObj.isActive = trainingModuleVersion.getIsActive() == null ? null : trainingModuleVersion.getIsActive() ? 1 : 0;
    if (trainingModuleVersion.getTrainingModuleId() != null) trainingModuleVersionObj.trainingModuleId = trainingModuleVersion.getTrainingModuleId();
    if (trainingModuleVersion.getTrainingModule() != null) trainingModuleVersionObj.trainingModule = _.TrainingModule.freeze(trainingModuleVersion.getTrainingModule());
    if (trainingModuleVersion.getAppVersions() != null) trainingModuleVersionObj.appVersions = _.AppVersion.freezeList(trainingModuleVersion.getAppVersions());
    if (trainingModuleVersion.getEvaluationVersions() != null) trainingModuleVersionObj.evaluationVersions = _.EvaluationVersion.freezeList(trainingModuleVersion.getEvaluationVersions());
    if (trainingModuleVersion.getContinuingEducationCredits() != null) trainingModuleVersionObj.continuingEducationCredits = trainingModuleVersion.getContinuingEducationCredits();
    if (trainingModuleVersion.getEvaluatorTrainings() != null) trainingModuleVersionObj.evaluatorTrainings = _.EvaluatorTraining.freezeList(trainingModuleVersion.getEvaluatorTrainings());
    return trainingModuleVersionObj;
  }

  static freezeList(trainingModuleVersions) {
    if (trainingModuleVersions == null) return [];
    var trainingModuleVersionObjList = [];

    for (var i = 0; i < trainingModuleVersions.length; i++) {
      trainingModuleVersionObjList.push(TrainingModuleVersion.freeze(trainingModuleVersions[i]));
    }

    return trainingModuleVersionObjList;
  }

  constructor() {
    this.setId(null);
    this.setSemanticVersion(null);
    this.setReleaseDate(null);
    this.setIsActive(null);
    this.setTrainingModuleId(null);
    this.setTrainingModule(null);
    this.setAppVersions(null);
    this.setEvaluationVersions(null);
    this.setContinuingEducationCredits(null);
    this.setEvaluatorTrainings(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setSemanticVersion(semanticVersion) {
    this.semanticVersion = semanticVersion;
  }

  setReleaseDate(releaseDate) {
    this.releaseDate = releaseDate;
  }

  setIsActive(isActive) {
    this.isActive = isActive;
  }

  setTrainingModuleId(trainingModuleId) {
    this.trainingModuleId = trainingModuleId;
  }

  setTrainingModule(trainingModule) {
    this.trainingModule = trainingModule;
  }

  setAppVersions(appVersions) {
    this.appVersions = appVersions;
  }

  setEvaluationVersions(evaluationVersions) {
    this.evaluationVersions = evaluationVersions;
  }

  setContinuingEducationCredits(continuingEducationCredits) {
    this.continuingEducationCredits = continuingEducationCredits;
  }

  setEvaluatorTrainings(evaluatorTrainings) {
    this.evaluatorTrainings = evaluatorTrainings;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getSemanticVersion() {
    return this.semanticVersion;
  }

  getReleaseDate() {
    return this.releaseDate;
  }

  getIsActive() {
    return this.isActive;
  }

  getTrainingModuleId() {
    return this.trainingModuleId;
  }

  getTrainingModule() {
    return this.trainingModule;
  }

  getAppVersions() {
    return this.appVersions;
  }

  getEvaluationVersions() {
    return this.evaluationVersions;
  }

  getContinuingEducationCredits() {
    return this.continuingEducationCredits;
  }

  getEvaluatorTrainings() {
    return this.evaluatorTrainings;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = TrainingModuleVersion;